import React from "react";
import ColumnRenderers from "components/events/events/ColumnRenderers";
import EventDetailsDefinitionList from "components/events/events/EventDetailsDefinitionList";
import { useGetEventDefinition } from "components/event-definitions/hooks/useEventDefinitions";
import { Spinner } from "components/common";
const GeneralEventDetailsTable = ({ event, attributesList, meta }) => {
  var _a;
  const { event_definition_id } = event;
  const { data, isFetching } = useGetEventDefinition(event_definition_id);
  if (isFetching) return /* @__PURE__ */ React.createElement(Spinner, null);
  const eventDefinitionEventProcedureId = ((_a = data == null ? void 0 : data.eventDefinition) == null ? void 0 : _a.event_procedure) || "";
  return /* @__PURE__ */ React.createElement(
    EventDetailsDefinitionList,
    {
      event,
      meta,
      eventProcedureId: eventDefinitionEventProcedureId,
      attributesRenderers: ColumnRenderers.attributes,
      attributesList
    }
  );
};
export default GeneralEventDetailsTable;
